import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dropdownMenuInjectionKey as c, dropdownInjectionKey as b } from "./context.js";
import { render as u } from "../../_utils/vue/render.js";
import { defineComponent as f, inject as l, h as r } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const _ = f({
  name: "DropdownGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const {
      showIconRef: n,
      hasSubmenuRef: o
    } = l(c), {
      renderLabelRef: i,
      labelFieldRef: p,
      nodePropsRef: d,
      renderOptionRef: t
    } = l(b);
    return {
      labelField: p,
      showIcon: n,
      hasSubmenu: o,
      renderLabel: i,
      nodeProps: d,
      renderOption: t
    };
  },
  render() {
    var n;
    const {
      clsPrefix: o,
      hasSubmenu: i,
      showIcon: p,
      nodeProps: d,
      renderLabel: t,
      renderOption: s
    } = this, {
      rawNode: e
    } = this.tmNode, a = r("div", Object.assign({
      class: `${o}-dropdown-option`
    }, d == null ? void 0 : d(e)), r("div", {
      class: `${o}-dropdown-option-body ${o}-dropdown-option-body--group`
    }, r("div", {
      "data-dropdown-option": !0,
      class: [`${o}-dropdown-option-body__prefix`, p && `${o}-dropdown-option-body__prefix--show-icon`]
    }, u(e.icon)), r("div", {
      class: `${o}-dropdown-option-body__label`,
      "data-dropdown-option": !0
    }, t ? t(e) : u((n = e.title) !== null && n !== void 0 ? n : e[this.labelField])), r("div", {
      class: [`${o}-dropdown-option-body__suffix`, i && `${o}-dropdown-option-body__suffix--has-submenu`],
      "data-dropdown-option": !0
    })));
    return s ? s({
      node: a,
      option: e
    }) : a;
  }
});
export {
  _ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dropdown/src/DropdownGroupHeader.js
// module id = 1639
// module chunks = 41